import { Card } from "@/shared/components/ui/card"
import { Badge } from "@/shared/components/ui/badge" 
import {
  CheckCircle2,
  FileJson,
  Shield,
  Cloud,
  Headphones,
  BarChart3,
  ClipboardPen,
  ArrowRight,
  Hospital,
  FlaskRound,
  Stethoscope,
  Cross,
  Ambulance,
  FileCheck,
  Upload, 
  CheckCircle,
  Zap
} from "lucide-react"
import { Button } from "@/shared/components/ui/button"
import { Link } from "react-router-dom"

const services = [
  {
    icon: FileJson,
    title: "Validación de Archivos JSON",
    description:
      "Garantiza la exactitud y conformidad de tus reportes con nuestro servicio de validación de formatos JSON según el nuevo mecanismo de validación RIPS. Ideal para el sector salud en Colombia, asegurando datos precisos y normativos.",
    features: [
      "Validación en tiempo real",
      "Detección automática de errores",
      "Cumplimiento normativo garantizado",
      "Reportes detallados de validación",
    ],
    badge: "Automatizado",
    color: "from-blue-500/10 to-cyan-500/10",
    iconBg: "bg-blue-500/10",
    iconColor: "text-blue-600 dark:text-blue-400",
  },
  {
    icon: Shield,
    title: "Facturación Electrónica Sector Salud",
    description:
      "Automatiza y simplifica tus procesos de facturación con Rapyfact. Nuestros planes están diseñados para adaptarse a las necesidades de tu negocio, garantizando seguridad, eficiencia y cumplimiento normativo.",
    features: [
      "Validación RIPS automática",
      "Integración con sistemas de salud",
      "Cumplimiento normativo sector salud",
      "Soporte especializado",
    ],
    badge: "Esencial",
    color: "from-emerald-500/10 to-teal-500/10",
    iconBg: "bg-emerald-500/10",
    iconColor: "text-emerald-600 dark:text-emerald-400",
  },
  {
    icon: Cloud,
    title: "Almacenamiento Seguro en la Nube",
    description:
      "Almacenamiento seguro y confiable de todas tus facturas electrónicas y Rips json con acceso desde cualquier lugar.",
    features: [
      "Almacenamiento ilimitado",
      "Backup automático",
      "Acceso desde cualquier dispositivo",
      "Seguridad de nivel empresarial",
    ],
    badge: "Seguro",
    color: "from-purple-500/10 to-pink-500/10",
    iconBg: "bg-purple-500/10",
    iconColor: "text-purple-600 dark:text-purple-400",
  },
  {
    icon: Headphones,
    title: "Soporte Técnico 24/7",
    description: "Equipo de expertos disponible las 24 horas para resolver cualquier duda o problema técnico.",
    features: [
      "Soporte por chat, email y teléfono",
      "Respuesta en menos de 2 horas",
      "Capacitación personalizada",
      "Documentación completa",
    ],
    badge: "Disponible",
    color: "from-orange-500/10 to-amber-500/10",
    iconBg: "bg-orange-500/10",
    iconColor: "text-orange-600 dark:text-orange-400",
  },
  {
    icon: BarChart3,
    title: "Gestión de Citas Médicas",
    description:
      "Organiza y administra tus citas médicas de manera rápida y eficiente. Nuestra plataforma permite programar, modificar y gestionar tus agendas desde cualquier dispositivo, optimizando el tiempo de atención tanto para el profesional como para el paciente. Recibe notificaciones automáticas, evita cruces de horarios y mantén tus registros actualizados. El sistema se adapta a las necesidades de profesionales independientes, IPS y EPS, facilitando la coordinación de múltiples especialidades y sedes.",
    features: [
      "Agenda digital centralizada",
      "Recordatorios automáticos a pacientes",
      "Control de disponibilidad y horarios",
      "Reprogramación fácil e intuitiva",
      "Sincronización con historias clínicas",
    ],
    badge: "Eficiente",
    color: "from-indigo-500/10 to-blue-500/10",
    iconBg: "bg-indigo-500/10",
    iconColor: "text-indigo-600 dark:text-indigo-400",
  },
  {
    icon: ClipboardPen,
    title: "Gestión Integral de Historias Clínicas Digitales",
    description:
      "Optimiza la gestión de tus pacientes con nuestro sistema de historias clínicas digitales adaptables. Diseñado para profesionales independientes, IPS y EPS, te permite administrar, almacenar y consultar la información médica de forma rápida, segura y centralizada. Nos adaptamos a las necesidades específicas de cada servicio de salud, personalizando los formatos según tus requerimientos o el modelo que nos proporciones. Nuestra plataforma garantiza seguridad, trazabilidad y cumplimiento normativo, mejorando la eficiencia y la atención al paciente.",
    features: ["Medicina general", "Fisioterapia", "Odontología", "Crecimiento y desarrollo"],
    badge: "Personalizable",
    color: "from-rose-500/10 to-red-500/10",
    iconBg: "bg-rose-500/10",
    iconColor: "text-rose-600 dark:text-rose-400",
  },
]

const sectores = [
  { nombre: "IPS y EPS", icono: Hospital, color: "from-blue-500 to-cyan-500" },
  { nombre: "Laboratorios", icono: FlaskRound, color: "from-blue-500 to-cyan-500" },
  { nombre: "Consultorios", icono: Stethoscope, color: "from-emerald-500 to-teal-500" },
  { nombre: "Odontólogos", icono: Cross, color: "from-blue-500 to-cyan-500" },
  { nombre: "Ambulancias", icono: Ambulance, color: "from-blue-500 to-cyan-500" },
]
const steps = [
    {
      icon: Upload,
      title: "1. Carga tu admisión",
      description: "Registra o importa la admisión del paciente Directo al sistema. Rapyfact procesa los datos clínicos y administrativos de forma segura para iniciar el ciclo de facturación.",
      color: "from-primary to-chart-4",
    },
    {
      icon: FileCheck,
      title: "2. Envío a la DIAN",
      description: "El sistema genera automáticamente la factura electrónica y la transmite a la DIAN con validación digital incluida, cumpliendo con los requisitos normativos vigentes.",
      color: "from-chart-4 to-chart-3",
    },
    {
      icon: Zap,
      title: "3. Validación del RIPS JSON",
      description: "Rapyfact construye y valida el archivo RIPS JSON conforme a la Resolución 2275.",
      color: "from-chart-3 to-primary",
    },
    {
      icon: CheckCircle,
      title: "4. Confirmación y obtención del CUV",
      description: "Una vez validado el RIPS JSON, Rapyfact obtiene automáticamente el CUV desde el Ministerio de Salud, dejando todo listo para su radicación y almacenado de forma segura en la nube.",
      color: "from-primary to-chart-4",
    },
  ]

export  function ServiciosPage() {
  return (
    <div className="relative min-h-screen">
      <div className="absolute inset-0 bg-grid-pattern opacity-40 pointer-events-none" />
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none animate-pulse" />
      <div
        className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl pointer-events-none animate-pulse"
        style={{ animationDelay: "1s" }}
      />
      <div className="absolute top-1/2 right-1/3 w-64 h-64 bg-blue-500/5 rounded-full blur-2xl pointer-events-none" />

      <div className="relative pt-32 pb-20 lg:pt-40 lg:pb-32">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Header section */}
          <div className="text-center max-w-4xl mx-auto mb-20 space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-1000">
            <Badge
              variant="outline"
              className="mb-4 px-4 py-1.5 text-sm font-medium border-primary/30 hover:border-primary/50 transition-colors"
            >
              Nuestros Servicios
            </Badge>
            <h1 className="text-4xl lg:text-6xl font-bold mb-6 text-balance leading-tight">
              Soluciones Integrales para el{" "}
              <span className="text-primary bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                Sector Salud
              </span>
            </h1>
            <p className="text-lg lg:text-xl text-muted-foreground leading-relaxed text-pretty max-w-3xl mx-auto">
              Simplificamos tu contabilidad y aseguramos el cumplimiento normativo con nuestra plataforma de facturación
              electrónica. Sube tus facturas y valida archivos JSON al instante con seguridad y eficiencia.
            </p>
          </div>

          {/* Services grid */}
          <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-20">
            {services.map((service, index) => (
              <Card
                key={index}
                className="group relative overflow-hidden border-2 hover:border-primary/50 transition-all duration-500 hover:shadow-2xl hover:shadow-primary/10 hover:-translate-y-1 animate-in fade-in slide-in-from-bottom-8 duration-700"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div
                  className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-100 transition-all duration-700`}
                />

                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-gradient-to-tr from-transparent via-white/5 to-transparent" />

                <div className="relative p-8 space-y-6">
                  {/* Icon and badge row */}
                  <div className="flex items-start justify-between gap-4">
                    <div
                      className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl ${service.iconBg} group-hover:scale-110 group-hover:rotate-3 transition-all duration-500 shadow-lg group-hover:shadow-xl`}
                    >
                      <service.icon
                        className={`w-8 h-8 ${service.iconColor} group-hover:scale-110 transition-transform duration-500`}
                      />
                    </div>
                    <Badge variant="secondary" className="text-xs font-medium shadow-sm">
                      {service.badge}
                    </Badge>
                  </div>

                  {/* Content */}
                  <div className="space-y-4">
                    <h3 className="text-2xl font-bold text-balance group-hover:text-primary transition-colors duration-300 leading-tight">
                      {service.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed text-pretty text-[15px]">
                      {service.description}
                    </p>
                  </div>

                  {/* Features list */}
                  <div className="pt-4 border-t border-border/50 group-hover:border-primary/20 transition-colors duration-500">
                    <ul className="space-y-3">
                      {service.features.map((feature, i) => (
                        <li key={i} className="flex items-start gap-3 group/item">
                          <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 flex-shrink-0 group-hover/item:scale-125 group-hover/item:rotate-12 transition-all duration-300" />
                          <span className="text-sm leading-relaxed group-hover/item:text-foreground transition-colors duration-300">
                            {feature}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          <div className="max-w-4xl mx-auto mb-24 lg:mb-32 animate-in fade-in slide-in-from-bottom-8 duration-1000">
            <Card className="relative overflow-hidden border-2 border-primary/20 bg-gradient-to-br from-primary/5 to-primary/10 hover:border-primary/30 transition-all duration-500 hover:shadow-2xl hover:shadow-primary/20">
              <div
                className="absolute inset-0 bg-gradient-to-r from-primary/10 via-transparent to-primary/10 animate-pulse"
                style={{ animationDuration: "3s" }}
              />

              <div className="relative p-8 lg:p-12 text-center space-y-6">
                <h2 className="text-3xl lg:text-4xl font-bold text-balance leading-tight">
                  ¿Listo para transformar tu gestión de salud?
                </h2>
                <p className="text-lg text-muted-foreground max-w-2xl mx-auto text-pretty leading-relaxed">
                  Únete a cientos de profesionales y organizaciones que ya confían en Rapyfact para optimizar sus
                  procesos.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
                  <Button asChild size="lg" className="group shadow-lg hover:shadow-xl transition-all duration-300">
                    <Link to="/elige-tu-plan">
                      Ver Planes
                      <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
                    </Link>
                  </Button>
                  <Button
                    asChild
                    size="lg"
                    variant="outline"
                    className="shadow-md hover:shadow-lg transition-all duration-300 bg-transparent"
                  >
                    <Link to="/contacto">Contactar Ventas</Link>
                  </Button>
                </div>
              </div>
            </Card>
          </div>

          {/* Health sector section */}
          <section
            className="animate-in fade-in slide-in-from-bottom-8 duration-1000"
            style={{ animationDelay: "200ms" }}
          >
            <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
              <Badge
                variant="outline"
                className="mb-4 px-4 py-1.5 text-sm font-medium border-primary/30 hover:border-primary/50 transition-colors"
              >
                Sectores Especializados
              </Badge>
              <h2 className="text-3xl lg:text-5xl font-bold text-balance leading-tight">
                Especializado en el{" "}
                <span className="text-primary bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                  Sector Salud
                </span>
              </h2>
              <p className="text-lg text-muted-foreground leading-relaxed text-pretty">
                Diseñado para Clínicas, Ambulancias, Odontólogos y Profesionales de la Salud que necesitan cumplir con
                los estándares de facturación electrónica y envío de RIPS sin complicaciones.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-6">
              {sectores.map(({ nombre, icono: Icon, color }, index) => (
                <Card
                  key={index}
                  className="group relative overflow-hidden border-2 hover:border-primary/50 transition-all duration-500 hover:shadow-xl hover:shadow-primary/10 hover:-translate-y-2 animate-in fade-in zoom-in-95 duration-700"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <div
                    className={`absolute inset-0 bg-gradient-to-br ${color} opacity-0 group-hover:opacity-15 transition-all duration-700`}
                  />

                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 bg-gradient-to-tr from-transparent via-white/5 to-transparent" />

                  <div className="relative p-6 lg:p-8 flex flex-col items-center justify-center text-center space-y-4 min-h-[160px]">
                    <div className="relative">
                      <div
                        className={`absolute inset-0 bg-gradient-to-br ${color} opacity-20 blur-xl group-hover:opacity-50 group-hover:scale-125 transition-all duration-700`}
                      />
                      <div className="relative inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/5 group-hover:bg-primary/10 transition-all duration-500 shadow-lg group-hover:shadow-xl group-hover:scale-110">
                        <Icon
                          className="w-8 h-8 text-primary group-hover:scale-110 group-hover:rotate-6 transition-all duration-500"
                          strokeWidth={1.8}
                        />
                      </div>
                    </div>
                    <span className="text-base lg:text-lg font-semibold group-hover:text-primary transition-colors duration-300">
                      {nombre}
                    </span>
                  </div>
                </Card>
              ))}
            </div>
          </section>
          
    <section className="relative py-20 lg:py-32 overflow-hidden bg-gradient-to-b from-muted/20 to-background">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:4rem_4rem]" />

      <div className="container relative mx-auto px-4 lg:px-8">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16 lg:mb-24">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <Zap className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">Proceso simple</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-balance">
            ¿Cómo funciona{" "}
            <span className="bg-gradient-to-r from-primary to-chart-3 bg-clip-text text-transparent">Rapyfact</span>{" "} en tu proceso de facturación y validación?
          </h2>
          <p className="text-xl text-muted-foreground text-pretty">
            Cuatro pasos claros para generar, validar y obtener el CUV cumpliendo la Resolución 2275 del MINSALUD.
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-primary via-chart-4 via-chart-3 to-primary opacity-20" />

          {steps.map((step, index) => {
            const Icon = step.icon
            return (
              <div key={index} className="relative group" style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="relative bg-card border border-border rounded-2xl p-8 hover:border-primary/30 transition-all duration-300 hover:shadow-xl hover:shadow-primary/5 h-full">
                  {/* Icon */}
                  <div className="relative mb-6">
                    <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${step.color} p-0.5 shadow-lg`}>
                      <div className="w-full h-full bg-card rounded-xl flex items-center justify-center">
                        <Icon className="w-8 h-8 text-primary" />
                      </div>
                    </div>
                    {/* Step number badge */}
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gradient-to-br from-primary to-chart-4 text-white text-sm font-bold flex items-center justify-center shadow-lg">
                      {index + 1}
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold mb-3 text-foreground group-hover:text-primary transition-colors">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">{step.description}</p>

                  {/* Hover effect */}
                  <div
                    className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${step.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  
        </div>
      </div>
    </div>
  )
}
